import { authFetch } from "utils";

export const getByAssetLead = (id) =>
  authFetch(`${apiUrl}${version}/asset_leads/${id}/posts`, {
    method: "GET",
  });

export const getByDeal = (id) =>
  authFetch(`${apiUrl}${version}/deals/${id}/posts`, {
    method: "GET",
  });
